module.exports = __webpack_public_path__ + "media/images/vp/parallax.new.06.a-db40a295255418b624beccb87e159c55.svg";